unit UFeiertagModel;

interface

uses
  Js;

type
  TFeiertagModel = class
  private
    FAktiv: Boolean;
    FBezeichnung: string;
    FBezahlt: Boolean;
    FDatum: TDateTime;
    procedure ClearValues;
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetAktiv(const Value: Boolean);
    procedure SetBezahlt(const Value: Boolean);
    procedure SetBezeichnung(const Value: string);
    procedure SetDatum(const Value: TDateTime);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    property Datum: TDateTime read FDatum write SetDatum;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property Aktiv: Boolean read FAktiv write SetAktiv;
    property Bezahlt: Boolean read FBezahlt write SetBezahlt;
  end;

implementation

uses
  System.SysUtils, UEssentialHelper;

{ TFeiertagModel }

procedure TFeiertagModel.ClearValues;
begin
  Self.Datum := 0;
  Self.Bezeichnung := '';
  Self.Aktiv := true;
  Self.Bezahlt := true;
end;

constructor TFeiertagModel.Create;
begin
  Self.ClearValues;
end;

constructor TFeiertagModel.Create(Json: string);
begin
  Self.SetValues(Json);
end;

procedure TFeiertagModel.SetAktiv(const Value: Boolean);
begin
  FAktiv := Value;
end;

procedure TFeiertagModel.SetBezahlt(const Value: Boolean);
begin
  FBezahlt := Value;
end;

procedure TFeiertagModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TFeiertagModel.SetDatum(const Value: TDateTime);
begin
  FDatum := Value;
end;

procedure TFeiertagModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['Datum'] <> nil then
    Self.Datum := StrToDateTime(string(Obj['Datum']));
  if Obj['Bezeichnung'] <> nil then
    Self.Bezeichnung := string(Obj['Bezeichnung']);
  if Obj['Aktiv'] <> nil then
    Self.Aktiv := StrToBoolean(string(Obj['Aktiv']));
  if Obj['Bezahlt'] <> nil then
    Self.Bezahlt := StrToBoolean(string(Obj['Bezahlt']));
end;

procedure TFeiertagModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

end.
